export const useAnnotationTypesStore = () => {
  return useAnnotationTypes()();
};
